import { useEffect, useState } from "react"

function isFileDrag(evt: DragEvent) {
    return Array.from(evt.dataTransfer?.types || []).includes('Files')
}

export const useDocumentDragState = () => {
    const [isDragging, setIsDragging] = useState(false)

    const onDrop = () => setIsDragging(false)

    useEffect(() => {
        const handleDragEnter = (evt: DragEvent) => {
            if (isFileDrag(evt)) {
                evt.preventDefault()
                setIsDragging(true)
            }
        }
        const handleDragLeave = (evt: DragEvent) => {
            if (!document.contains(evt.relatedTarget as Node)) {
                evt.preventDefault()
                setIsDragging(false)
            }
        }
        const handleDragOver = (evt: DragEvent) => {
            if (isFileDrag(evt)) {
                evt.preventDefault()
                setIsDragging(true)
            }
        }
        const handleDrop = (evt: DragEvent) => {
            evt.preventDefault()
            setIsDragging(false)
        }

        document.addEventListener('dragenter', handleDragEnter)
        document.addEventListener('dragleave', handleDragLeave)
        document.addEventListener('dragover', handleDragOver)
        document.addEventListener('drop', handleDrop)

        return () => {
            document.removeEventListener('dragenter', handleDragEnter)
            document.removeEventListener('dragleave', handleDragLeave)
            document.removeEventListener('dragover', handleDragOver)
            document.removeEventListener('drop', handleDrop)
        }
    }, [])

    return { isDragging, onDrop }
}
